<template>
    <div id = "chooseCity">

      <Picker v-if="showPiker" @picker-event="pickerEvent" :dataSlots="dataSlots" >

      </Picker>

      <div id="search" v-if="Object.keys(cityData).length > 0">
        <img src="../../../assets/icon/search.jpg" id="search-img"/>
        <div id="search-text-view">
          <div id="search-text" style="color:#BDBDBD" @click="searchClick">请输入城市进行搜索</div>
        </div>
        <div class="sparator search-sparator"></div>
      </div>

      <SearchCity v-if="showSearchCity" :cityData="cityData">

      </SearchCity>
      <mt-index-list :show-indicator="true" v-if="Object.keys(cityData).length > 0">

        <div id="header">

          <div id="header-localPosition">

            <img id="header-localPosition-img" src="../../../assets/icon/location.png"/>
            <div class="header-lp-city" @click="localPositionEvent">
              <div class="header-localPosition-lable header-localPosition-lable1">{{localCity}}</div>
              <div class="header-localPosition-lable header-localPosition-lable2">当前城市</div>
            </div>
            <div class="header-localPosition-sparator"></div>
          </div>


          <div id="header-hotCity">

            <div id="header-hotCity-center">
              <div class="header-hotCity-lable1">
                热门城市
              </div>
              <div class="header-hotCity-hotBtnView">
                <div v-for="(city,cIndex) in hotData" class="header-hotCity-hotBtn" :key="cIndex" @click="chooseCityEvent(city)">{{city.cityName}}</div>
              </div>
            </div>

          </div>
        </div>

        <mt-index-section v-bind:index="cityName"  v-for="(cityName,index) in cityNameData" id="section"  :key="index" >

          <div v-for="(city,cityIndex) in cityData[cityName]" class="parentCell" :key="cityIndex">

            <div class="wrapper">
              <div @click="selectedCity(city.name, city, false)"
                   v-bind:id="city.name" class="cell">
                  {{city.name}}
              </div>
              <div v-if="(cityIndex < (cityData[cityName].length-1)) || isShowChildCity[city.name]" class="sparator"></div>
            </div>

            <div class="wrapper" v-if="isShowChildCity[city.name]" v-for="(childCity,childCityIndex) in city.childCitys" :key="childCityIndex">
              <div @click="selectedCity(childCity.name, childCity, true)" class="cell cell-child">
                  {{childCity.name}}
              </div>
              <div v-if="(cityIndex < cityData[cityName].length-1) || childCityIndex < city.childCitys.length-1" class="sparator sparator-child"></div>
            </div>

          </div>
        </mt-index-section>
      </mt-index-list>

    </div>
</template>

<script>
    import mapHelper from '@/js/mapHelper'
    import api from '@/api/common/api.common'
    import bus from '@/js/eventBus'
    import SearchCity from './searchCity'
    import Picker from '../Picker/Picker.vue'
    export default {
      name: 'chooseCity',
      computed: {

      },
      components: {
        SearchCity,
        Picker
      },
      data () {
        return {
          dataList:[],
          dataCount: 0,
          addCount: 0,
          dataSlots: [],
          cityData: {
            //通过api获取数据后，重新封装成这个数据
//            'C': [{'name': '长沙', 'id': '123', childCitys: [{'name': '芙蓉区', 'id': '1245'}, {'name': '长沙市', 'id': '1246'}]},
//                  {'name': '长沙2', 'id': '124'},
//                  {'name': '长沙3', 'id': '125', childCitys: [{'name': '芙蓉区', 'id': '1245'}, {'name': '长沙市', 'id': '1246'}]}],
//            'S': [{'name': '深圳', 'id': '1'},
//                  {'name': '深圳2', 'id': '2'},
//                  {'name': '深圳3', 'id': '3'}]
          },
          isShowChildCity: {
            '长沙': false,
            '长沙3': false
          },
          localCity: '正在定位',
          address: {},
          hotData: [],
          showSearch: false,
          selectedChildCitys: [],
          showSearchCity: false,
          showPiker: false,
          cityNameData: []
        }
      },
      mounted () {
        var self = this

        bus.$on('closeSearchCity',function (data) {
          console.log(data)
          self.showSearchCity = data
        })

        // 定位
        mapHelper.getCurrentLocation(function (address) {
          self.address = address
          self.localCity = address.city
        })
        // 获取热门城市
        api.getHotCity({}, function (successRespond) {
          self.hotData = successRespond.body.data
        },function () {

        },false)
        //获取城市列表
        api.getAllXFCity({}, function (successRespond) {

          var cityData = {}
          var cityNameData = []
          var childCity = []

          let dataList = successRespond.body.data;
          self.dataList = dataList
          try {

            for (var x in dataList) {

              var city = dataList[x]
              var firstName = city.cityNamePingyin.slice(0,1).toLocaleUpperCase()

              if (cityData.hasOwnProperty(firstName)) {
                var cityInfo = self.getNewCity(city)
                    if (city.cityName === city.regionName) {
                      cityData[firstName].push(cityInfo)

                    } else { //将三级城市先存储下来，防止先读取到三级城市找不到市
                      if(city.isCity === 1){
                        childCity.push(cityInfo)
                      }
                    }
              } else {
                cityData[firstName] = []
                var cityInfo = self.getNewCity(city)

                  if (city.cityName === city.regionName) {
                    cityData[firstName].push(cityInfo)

                  } else { //将三级城市先存储下来，防止先读取到三级城市找不到市
                                    if (city.isCity === 1) {

                    childCity.push(cityInfo)}
                  }
                cityNameData.push(firstName)
              }

            }

            self.cityData = cityData
            cityNameData.sort()
            self.cityNameData = cityNameData

            var isShowChildCity = {}
            for (var x in childCity) {
              var cCity = childCity[x]
              var firstName = cCity.cityNameSpell.slice(0,1).toLocaleUpperCase()
              var citys = self.cityData[firstName]

              for (var y in citys) {
                var parentCity = citys[y]
                if (parentCity.name === cCity.name) {
                  isShowChildCity[cCity.name] = false
                  cCity.name = cCity.regionName
                  if (parentCity.hasOwnProperty('childCitys')) {
                    parentCity.childCitys.push(cCity)
                  } else {
                      var val = parentCity
                      parentCity.childCitys = []
                      if(parentCity.isCity == 1){
                        parentCity.childCitys.push(val)
                     
                      }
                      parentCity.childCitys.push(cCity)
                    
                  }
                }
              }

            }
          } catch (err) {
            self.utils.alert('获取城市列表失败，请尝试刷新页面')
          }

          self.isShowChildCity = isShowChildCity
          self.$store.dispatch('setCitys' , self.cityData);
        },function (err) {
          self.utils.alert('获取城市列表失败，请尝试刷新页面')
        })

      },
      methods: {
        backPath (self) {

          if (self.$route.query['url'] === undefined) {
            return '/'
          }

          return self.$route.query['url']
        },
        localPositionEvent () {
          if (this.localCity === '正在定位') {
            return
          }

          var isAV = false
          for (var x in Object.keys(this.cityData)) {
            var citys = this.cityData[Object.keys(this.cityData)[x]]

            for (var y in citys) {
              var city = citys[y]
              if (city.name === this.localCity) {
                if (city.hasOwnProperty('childCitys') && city.childCitys.length > 0) {
                  var pickerData = this.getChildCityPickerData(city,city.childCitys)
                  this.dataSlots = pickerData
                  this.showPiker = true
                  this.selectedChildCitys = city.childCitys
                  isAV = true
                  return
                } else {
                  this.cacheCity(city,this)

                  return
                }
              }
            }
          }

          if (!isAV) {
            this.utils.alert('当前城市暂未开通，敬请期待')
            var city = {}
            city.regionId = 440300
            city.cityId = 440300
            city.cityName = '深圳市'

            this.cacheCity(city,self)

          }
        },
        pickerEvent (eventObj) {
          this.showPiker = false;

          if(eventObj.hasOwnProperty('selectData')) {

            var cityName = eventObj.selectData[1]
            for (var i in this.selectedChildCitys) {
              var city = this.selectedChildCitys[i]
              console.log(city.cityName + cityName)
              console.log(city)
              if (city.name === cityName) {
                var self = this
                this.cacheCity(city,self)
              }
            }
          }

        },
        searchClick () {
          this.showSearchCity = true
        },
        searchTextChange (val) {

          bus.$emit('sendSearchCity', val.srcElement.value)
        },
        getNewCity (city) {
          var cityInfo = {}
          cityInfo.name = city.cityName.replace(/\s+/g,"");
          cityInfo.cityName = city.cityName.replace(/\s+/g,"");
          cityInfo.id = city.cityId;
          cityInfo.cityNameSpell = city.cityNamePingyin;
          cityInfo.cityId = city.cityId;
          cityInfo.provinceName = city.provinceName&&city.provinceName.replace(/\s+/g,"");
          cityInfo.regionName = city.regionName.replace(/\s+/g,"");
          cityInfo.regionId = city.regionId;
          cityInfo.regionNamePingyin = city.regionNamePingyin;
          cityInfo.isCity = city.isCity;

          return cityInfo
        },
        selectedCity (cityName, city, isChildCity) {
          var self = this
          var isShow = this.isShowChildCity[cityName]
          console.log(city)
          if (isShow !== undefined && !isChildCity) {
            this.isShowChildCity[cityName] = !isShow
          } else {
            var self = this
            this.cacheCity(city,self)
          }

        },
        cacheCity(city,self){
          var data = {}
          data.regionlismCityId = city.regionId
          api.cacheLocation(data,function (respond) {
            self.$store.dispatch('setUserCity' , city)
            localStorage.setItem('cacheKey', respond.body.data['cacheKey'])
            delete city.childCitys
            var cityStr = JSON.stringify(city)
            localStorage.setItem('locationCity', cityStr)
            console.log('---------------------')
            self.$router.push(self.backPath(self))
          })
        },
        chooseCityEvent (city) {
          if (city.hasThirdCity === 1 || city.hasThirdCity === '1') {
            var childCitys = this.getCityChild(city)

//            var pickerData = this.getChildCityPickerData(city,childCitys)
            var pickerData = []

            var data1 = {}
            data1.flex = 1
            data1.className = 'slot1'
            data1.values = [city.cityName]
            data1.textAlign = 'center'
            pickerData.push(data1)

            var data2 = {}
            data2.flex = 1
            data2.className = 'slot1'
            var values = []
            for (var i in childCitys) {
              var childCity = childCitys[i]
              values.push(childCity.name)
            }
            data2.values = values
            data2.textAlign = 'center'
            pickerData.push(data2)

            this.dataSlots = pickerData
            this.showPiker = true
            this.selectedChildCitys = childCitys
          } else {
            this.cacheCity(this.getCity(city),this)
          }
        },
        getCity (city2) {
          let cityObj = {};
          for (var x in Object.keys(this.cityData)) {
            var citys = this.cityData[Object.keys(this.cityData)[x]]

            for (var y in citys) {
              var city = citys[y]
              if (city.name === city2.cityName) {
                cityObj = city;
              }

              citys[y].childCitys&&citys[y].childCitys.forEach((item,index)=>{
                if(item.name === city2.cityName){
                  cityObj = item;
                }
              })
            }
          }
          return cityObj;
        },
        getCityChild (city2) {
          // 查找该城市三级城市列表
          let childCitysList = [];
          for (var x in Object.keys(this.cityData)) {
            var citys = this.cityData[Object.keys(this.cityData)[x]]

            for (var y in citys) {
              var city = citys[y]
              var cityNameSpell = city.cityNameSpell.replace(/\s+/g, "")
              if (city.name === city2.cityName) {
                childCitysList =  city.childCitys
              }
            }
          }
          return childCitysList;
        },
        getChildCityPickerData (city,childCitys) {
          var pickerData = []

          var data1 = {}
          data1.flex = 1
          data1.className = 'slot1'
          data1.values = [city.cityName]
          data1.textAlign = 'center'
          pickerData.push(data1)

          var data2 = {}
          data2.flex = 1
          data2.className = 'slot1'
          var values = []
          for (var i in childCitys) {
            var childCity = childCitys[i]
            values.push(childCity.name)
          }
          data2.values = values
          data2.textAlign = 'center'
          pickerData.push(data2)

          return pickerData
        }
      }
    }
</script>

<style lang="scss">
  @import '../../../assets/css/mixin';

  input,button,select,textarea{outline:none;  border:none;}
  textarea{resize:none}

  #search {
    height: pxToRem(100px);
    position: relative;
  }
  #search-img {
    display: inline-block;
    margin-left: pxToRem(60px);
    margin-top: pxToRem(35px);
    height: auto;
    width: pxToRem(30px);
  }
  #search-text-view {
    display: inline-block;
    position: absolute;
    left: pxToRem(124px);
    top: 0px;
    bottom: 0px;

  }
  #search-text {
    position: absolute;
    top: pxToRem(32px);
    width: pxToRem(500px);
  }
  #search-close {
    position: absolute;
    right: pxToRem(74px);
    width: pxToRem(20px);
    height: auto;
    top: pxToRem(40px);
  }

  #header{
    /*height: pxToRem(386px);*/
  }


  #header-localPosition {
    height: pxToRem(156px);
    /*background-color: black;*/
    /*border-bottom: solid 1px #d8d8d8;*/
    position:relative;
  }
  #header-localPosition-img {
    width: pxToRem(20px);;
    display: inline;
    position: absolute;
    left: pxToRem(40px);
    top: pxToRem(100px);
  }
  .header-lp-city {
    display: inline;
    position: absolute;
    left: pxToRem(80px);
    top: pxToRem(80px);
    bottom: 0px;
  }
  .header-localPosition-lable {
    display: inline;
    color: #191919;
    line-height: pxToRem(80px);
    vertical-align: middle;
    font-size: $defaultSize;
    margin-right: pxToRem(16px);
  }
  .header-localPosition-lable2 {
    color: #CCCCCC;
    font-size: pxToRem(24px);
    line-height: pxToRem(80px);
  }


  #header-hotCity {
  }
  #header-hotCity-center {
    margin-left: 0px;
    margin-right: 20px;
  }
  .header-hotCity-lable1 {
    /*position:absolute;*/
    left: pxToRem(40px);
    margin-left: pxToRem(40px);
    margin-top: pxToRem(60px);
    font-size: pxToRem(24px);
  }
  .header-hotCity-hotBtn {
    /*flex:1 20%;*/
    width: pxToRem(180px);
    text-align: center;
    margin-left: pxToRem(40px);
    height: pxToRem(60px);
    margin-bottom: pxToRem(20px);
    color: #191919;
    padding-top: pxToRem(12px);
    /*line-height: pxToRem(40px);*/
    border: .5px solid rgba(102,102,102,1);
    font-size: pxToRem(24px);
  }
  .header-hotCity-hotBtnView {
    display: flex;
    flex-flow: row wrap;
    margin-top: pxToRem(20px);
    margin-bottom: pxToRem(40px);
  }

  .cell {
    background-color: white;
    text-align: left;
    height: pxToRem(62px);
    line-height: pxToRem(62px);
    width: 100%;
    vertical-align: middle;
    font-size: pxToRem(24px);;
    padding-left: pxToRem(40px);
  }
  .cell-child {
    padding-left: pxToRem(60px);
  }
  .wrapper {
    height: pxToRem(64px);
    padding-right: 20px;
    position: relative;
  }
  .sparator {
    /*width: 100%;*/
    height: 1px;
    position: absolute;
    bottom: 0px;
    left: pxToRem(18px);
    right: 0px;
    background-color: #d8d8d8;
  }
  .sparator-child {
    left: pxToRem(56px);
  }
  .search-sparator {
    left: pxToRem(0px);
  }
  .mint-indexsection-index{
    height: pxToRem(49px);
    background-color: #eeeeee;
    text-align: left;
    padding-left: pxToRem(40px);
    padding-top: pxToRem(10px);
    color: #bd8d46;
    font-size: pxToRem(24px);
  }
  #section-header {
    height: pxToRem(25px);
    background-color: #eeeeee;
  }
  .mint-indexlist-nav {
    border-left: solid 0px #ddd;
  }

  .header-localPosition-sparator {
    left: pxToRem(40px);
    top: pxToRem(155px);
    height: 1px;
    right: pxToRem(40px);
    display: inline;
    position: absolute;
    background-color: #d8d8d8;
  }


</style>



// WEBPACK FOOTER //
// chooseCity.vue?0ef1bcd7